import ApiService from './api.service';
import ApiError from '../exceptions/api.error';
import { ConfigItemDTO } from '@/models/ConfigItemDTO';

export default class ConfigService {

  /**
   * Get the configs corresponding at the authenticated SU user/participant
   * @throws ApiError
   */
  public static async fetchConfigs(className?: string): Promise<ConfigItemDTO[]> {
    return await ApiService.get(`${process.env.VUE_APP_PUBLIC_ROOT_API}/configItems?className=${className}`)
      .then((response: any) => {
        return response.data as ConfigItemDTO[];
      })
      .catch((error: any) => {
        throw new ApiError(error.response.status, error.response.statusText);
      });
  }
}
